module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo3-501cd522569d7553eeef33df9eefff70.jpg";